export default "__VITE_ASSET__pHEflgDIHKrNcqRWZQfsyw__"